import { trpc } from '@/shared/api/trpc';

const SIXTY_SECONDS = 60 * 1000;

// Opt out of batching: this query is slow (full-view scan, no date window)
// and would otherwise hold up the rest of the operations.* batch on first
// paint. Run it on its own request so the table can render immediately.
export const useFlaggedCountsData = () =>
  trpc.operations.flaggedCounts.useQuery(undefined, {
    refetchInterval: SIXTY_SECONDS,
    // Refetch on entry so the bullets reflect edits made elsewhere (planner),
    // not just the 60s poll cadence.
    refetchOnMount: 'always',
    staleTime: SIXTY_SECONDS,
    trpc: { context: { skipBatch: true } },
  });
